// extracted by mini-css-extract-plugin
export var $animation_name = "Tabs-module--$animation_name--8cfe3";
export var tabs__list = "Tabs-module--tabs__list--d5f1d";
export var tabs__noSelectionMade = "Tabs-module--tabs__noSelectionMade--77f30";
export var tabs__selectionMade = "Tabs-module--tabs__selectionMade--41a9a";